export default [{"url":"https://akumzy-0.api.invexerp.io","name":"Branch 1","port":"5036","isStore":true,"isHQ":true}]